import styled from 'styled-components';
import { AvatarGroup } from 'react-rainbow-components';

const StyledAvatar = styled(AvatarGroup)`
    abbr {
        background-color: gray;
    }
`;

export default StyledAvatar;
